module.exports = __webpack_public_path__ + "static/media/logo-transparent.3f7a3926.png";